export var FieldSectionType = /*#__PURE__*/ function(FieldSectionType) {
    FieldSectionType["Project"] = "PROJECT";
    FieldSectionType["ProjectPhase"] = "PROJECT_PHASE";
    FieldSectionType["Task"] = "TASK";
    FieldSectionType["Users"] = "USERS";
    FieldSectionType["Financial"] = "FINANCIAL";
    FieldSectionType["Sprint"] = "SPRINT";
    FieldSectionType["Company"] = "COMPANY";
    FieldSectionType["Timeoff"] = "TIMEOFF";
    FieldSectionType["Invoice"] = "INVOICE";
    FieldSectionType["CreditNote"] = "CREDIT_NOTE";
    FieldSectionType["Budget"] = "PROJECT_FINANCIALS_BUDGET";
    FieldSectionType["Epic"] = "EPIC";
    FieldSectionType["Backlog"] = "BACKLOG";
    FieldSectionType["TimeEntry"] = "TIME_ENTRY";
    FieldSectionType["Expense"] = "EXPENSE";
    FieldSectionType["ResourceAllocation"] = "RESOURCE_ALLOCATION";
    FieldSectionType["Sheet"] = "SHEET";
    FieldSectionType["Reports"] = "REPORTS";
    return FieldSectionType;
}({});
export var FieldSectionSubType = /*#__PURE__*/ function(FieldSectionSubType) {
    FieldSectionSubType["Default"] = "DEFAULT";
    FieldSectionSubType["Skill"] = "SKILL";
    FieldSectionSubType["ExternalUser"] = "EXTERNAL_TEAM_MEMBER";
    FieldSectionSubType["InvoiceProject"] = "INVOICE_PROJECT";
    return FieldSectionSubType;
}({});
export var FieldTypeDisplay = /*#__PURE__*/ function(FieldTypeDisplay) {
    FieldTypeDisplay["Level"] = "LEVEL";
    return FieldTypeDisplay;
}({});
